// extracted by mini-css-extract-plugin
export default {"icon":"Notification_icon__Jevoy","message":"Notification_message__kHv79"};